/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';
import * as types from 'src/shared/domain/keyword/action/keywordActionTypes';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialState = {
  isFetching: false,
  result: [],
  count: 0,
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const handleRequest = (state: Object, { isOffset }: Object) => ({
  ...state,
  isFetching: true,
  result: isOffset ? state.result : [],
  count: isOffset ? state.count : 0,
});

const handleSuccess = (state: Object, { result, isOffset }: Object) => {
  const { results: keywords, count } = result;

  return {
    ...state,
    isFetching: false,
    result: isOffset ? [...state.result, ...keywords] : keywords,
    count,
  };
};

const reset = (state: Object, { isOffset }: Object) => ({
  ...state,
  isFetching: false,
  result: isOffset ? state.result : [],
  count: isOffset ? state.count : 0,
});

export default createReducer(initialState, {
  [types.FETCH_KEYWORDS_REQUEST]: handleRequest,
  [types.FETCH_KEYWORDS_SUCCESS]: handleSuccess,
  [types.FETCH_KEYWORDS_FAILURE]: reset,
  [types.RESET_KEYWORDS]: reset,
});
